import {ExclamationIcon} from '@primer/octicons-react'
import {MergeabilityFailureIcon} from '@github-ui/custom-icons/MergeabilityFailureIcon'
import {ForYouItem} from '../shared/ForYouItem'
import {useMergeabilityData} from './use-mergeability-data'
import {OverviewMergeControl} from './shared/OverviewMergeControl'
import {getBranchUpdateRequirement, OverviewUpdateBranchControl} from './shared/OverviewUpdateBranchControl'
import {Banner} from '@primer/react'
import {useState} from 'react'
import {announce} from '@github-ui/aria-live'

export function UpdateBranch() {
  const data = useMergeabilityData()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  if (!data) return null

  const updateRequirement = getBranchUpdateRequirement(data)

  if (!updateRequirement) return null

  const isRequired = updateRequirement === 'required'

  return (
    <ForYouItem
      itemId="update-branch"
      visual={
        isRequired
          ? {kind: 'icon', icon: MergeabilityFailureIcon, tone: 'danger', glyphSize: 12}
          : {kind: 'icon', icon: ExclamationIcon, tone: 'attention', glyphSize: 12}
      }
      title={isRequired ? 'Required to update' : 'Out of date'}
      subText={
        isRequired
          ? 'Update your branch with the base branch before merging.'
          : 'Update your branch with the base branch when convenient.'
      }
      actions={[
        {
          id: 'update-branch',
          content: (
            <OverviewUpdateBranchControl
              itemName="update-branch"
              onError={error => {
                setErrorMessage(error)
                // The visible Banner below is not a live region, so screen-reader users focused on
                // the update button would otherwise hear nothing when the mutation fails.
                if (error) announce(error, {assertive: true})
              }}
            />
          ),
        },
        {
          id: 'merge',
          content: (
            <OverviewMergeControl
              data={data}
              itemName="update-branch"
              fallbackAction={isRequired ? 'view-status' : 'merge'}
            />
          ),
        },
      ]}
      footer={
        errorMessage && (
          <Banner className="tmp-m-3" variant="critical" title="Error" hideTitle>
            {errorMessage}
          </Banner>
        )
      }
    />
  )
}
